import { ElementRef, Injectable } from '@angular/core';
import { NgxToastrServiceService } from './ngx-toastr-service.service';
import { SweetAlertServiceService } from './sweet-alert-service.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class MessageServiceService {
  constructor(private toastrService: NgxToastrServiceService, private sweetAlertService: SweetAlertServiceService) { }

  //Show toast message using toastr plugin
  showToastMessage(msgType?: string, msgBody?: string, msgTitle?: string, showCloseBtn?: boolean, showHtml?: boolean, customTimeOut?: number, customExtendedTimeOut?: number, showProgressBar?: boolean) {
    showProgressBar = showProgressBar == null || showProgressBar == undefined ? true : showProgressBar;
    if (msgType === 'success') {
      this.toastrService.showSuccessToast(msgBody, msgTitle, showCloseBtn, showHtml, customTimeOut, customExtendedTimeOut, showProgressBar);
    } else if (msgType === 'error') {
      this.toastrService.showErrorToast(msgBody, msgTitle, showCloseBtn, showHtml, customTimeOut, customExtendedTimeOut, showProgressBar);
    } else if (msgType === 'info') {
      this.toastrService.showInfoToast(msgBody, msgTitle, showCloseBtn, showHtml, customTimeOut, customExtendedTimeOut, showProgressBar);
    } else if (msgType === 'warning') {
      this.toastrService.showWarningToast(msgBody, msgTitle, showCloseBtn, showHtml, customTimeOut, customExtendedTimeOut, showProgressBar);
    } else {
      this.toastrService.showToast(msgBody, msgTitle, showCloseBtn, showHtml, customTimeOut, customExtendedTimeOut, showProgressBar);
    }
  }

  //Show pop up message using sweet alert 2 plugin
  showPopUpMessage(icon?: SweetAlertIcon, title?: any, text?: string, html?: string, showCancelButton?: boolean, cancelButtonText?: string, showConfirmButton?: boolean, confirmButtonText?: string,
    confirmButtonColor?: string, cancelButtonColor?: string, focusConfirm?: boolean, focusCancel?: boolean, reverseButtons?: boolean) {
    this.sweetAlertService.showSwalPopUpMessage(icon, title, text, html, showCancelButton, cancelButtonText, showConfirmButton, confirmButtonText, confirmButtonColor, cancelButtonColor,
      focusConfirm, focusCancel, reverseButtons);
  }

  //Experimental - Show toast message using sweet alert 2 plugin
  showSwalToastMessage(icon?: string, title?: any, text?: string, timer?: number, timerProgressBar?: boolean) {
    this.sweetAlertService.showSwalToastMessage(icon, title, text, timer, timerProgressBar);
  }

  //Experimental - Show call back pop up message using sweet alert 2 plugin
  showSwalFocusPopUpMessage(icon?: SweetAlertIcon, title?: any, text?: string, control?: ElementRef, html?: string, showCancelButton?: boolean, cancelButtonText?: string, showConfirmButton?: boolean, confirmButtonText?: string,
    confirmButtonColor?: string, cancelButtonColor?: string, focusConfirm?: boolean, focusCancel?: boolean, reverseButtons?: boolean) {
    this.sweetAlertService.showSwalFocusPopUpMessage(icon, title, text, control, html, showCancelButton, cancelButtonText, showConfirmButton, confirmButtonText, confirmButtonColor, cancelButtonColor,
      focusConfirm, focusCancel, reverseButtons);
  }
}
